unit GiftAidClaimForm;
interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  JobBaseForm,
  WEBLib.ExtCtrls,
  Data.DB,
  WEBLib.DB,
  XData.Web.JsonDataset,
  XData.Web.Dataset,
  WEBLib.WebCtrls,
  Vcl.Controls,
  Vcl.StdCtrls,
  WEBLib.Grids,
  WEBLib.DBCtrls,
  WEBLib.StdCtrls,
  Vcl.Mask,
  WEBLib.Mask,
  WEBLib.CDS, DB,
  GA.Return.Types, Vcl.Imaging.GIFImg;


type
  TClaimJobToPlace = (cjpPrepareClaim, cjpSubmitPreparedClaim);

  TGiftAidClaimJob = class(TJobBase)
    AgreeCheckBox: TCheckBox;
    AuthorisedOfficial: TLookupComboBox;
    AuthOfficials: TXDataWebDataSet;
    AuthOfficialsId: TIntegerField;
    AuthOfficialsFirstName: TStringField;
    AuthOfficialsLastName: TStringField;
    ConfigDataset: TXDataWebDataSet;
    ConfigDatasetId: TIntegerField;
    ConfigDatasetHMRCOfficial: TIntegerField;
    ConfigDatasetCharityRef: TStringField;
    ConfigDatasetCharityType: TStringField;
    ConfigDatasetGatewayId: TStringField;
    ConfigDatasetGatewayPassword: TStringField;
    ConfigDatasetRegulator: TStringField;
    ConfigDatasetRegulatorNumber: TStringField;
    ConfigDatasetEndOfYear: TStringField;
    ConfigDatasetOrganisationType: TStringField;
    ConfigDatasetOrganisationName: TStringField;
    ConfigDatasetSubmissionMethod: TStringField;
    ErrorHandling: TLookupComboBox;
    JobsPlacedDateAdded: TDateTimeField;
    JobsPlacedAddedBy: TIntegerField;
    JobsPlacedLastUpdatedBy: TIntegerField;
    JobsPlacedLastUpdated: TDateTimeField;
    JobsPlacedJobCategory: TStringField;
    JobsPlacedLastPolled: TDateTimeField;
    JobsPlacedPollInterval: TLargeintField;
    JobsPlacedPollCount: TIntegerField;
    HMRCPassword: TEdit;
    GAUsers: TClientDataSet;
    UserClaimRef: TEdit;
    InitialCheck: TTimer;
    DisplayClaimDeclaration: TTimer;
    ClaimDeclaration: TXDataWebDataSet;
    ClaimDeclarationId: TIntegerField;
    ClaimDeclarationDateAdded: TDateTimeField;
    ClaimDeclarationAddedBy: TIntegerField;
    ClaimDeclarationLastUpdatedBy: TIntegerField;
    ClaimDeclarationLastUpdated: TDateTimeField;
    ClaimDeclarationClaimId: TIntegerField;
    ClaimDeclarationDeclarationVersion: TIntegerField;
    ClaimDeclarationDeclarationHash: TStringField;
    ClaimDeclarationDeclarationIssueDate: TDateTimeField;
    ClaimDeclarationDeclarationExpiryDate: TDateTimeField;
    ClaimDeclarationDeclarationSignedDate: TDateTimeField;
    ClaimDeclarationDeclarationSignedByUser: TIntegerField;
    ClaimDeclarationDeclarationByName: TStringField;
    ClaimDeclarationDeclarationSigningChannel: TStringField;
    ClaimDeclarationDeclarationStatus: TStringField;
    ClaimDeclarationSignedDeclarationText: TStringField;
    PrepareClaimDataXXX: TTableControl;
    OldestDateParameter: TDateTimePicker;
    NewestDateParameter: TDateTimePicker;
    ImportFiles: TLookupComboBox;
    PrepareWaitMessage: TWaitMessage;
    CancelPrepareClaimButton: TButton;
    PrepareClaimButton: TButton;
    PrepareClaimTimer: TTimer;
    DeclarationTextMemo: TMemo;
    PrepareClaimData: TTableControl;
    ViewClaimDonationsButton: TButton;
    procedure WebFormCreate(Sender: TObject);
    procedure AgreeCheckBoxClick(Sender: TObject);
    procedure AuthOfficialsAfterOpen(Dataset: TDataSet);
    procedure AuthorisedOfficialChange(Sender: TObject);
    procedure AuthorisedOfficialExit(Sender: TObject);
    procedure ConfigDatasetAfterOpen(Dataset: TDataSet);
    procedure HMRCPasswordExit(Sender: TObject);
    procedure UserClaimRefExit(Sender: TObject);
    procedure InitialCheckTimer(Sender: TObject);
    procedure PlaceJobButtonClick(Sender: TObject);
    procedure PlaceSubmissionJobButtonClick(Sender: TObject);
    //procedure WebFormShow(Sender: TObject);
    procedure UserClaimRefChange(Sender: TObject);
    procedure CancelPrepareClaimButtonClick(Sender: TObject);
    procedure DisplayClaimDeclarationTimer(Sender: TObject);
    procedure ClaimDeclarationAfterPost(DataSet: TDataSet);
    procedure PrepareClaimButtonClick(Sender: TObject);
    procedure PrepareClaimTimerTimer(Sender: TObject);
    procedure ParameterChange(Sender: TObject);
    [async]
    procedure ViewClaimDonationsButtonClick(Sender: TObject); async;
  private
    { Private declarations }
    FRememberPasswordEnabled: boolean;
    FJobToPlace: TClaimJobToPlace;
    FPrepareDataReviewed: boolean;
    FPrepareJobCreated: boolean;
    FClaimId: integer;
    FGatewayId: string;
    FDeclarationVersionText: string;
    FDeclarationHash: string;
    FUserClaimRef: string;
    FUserClaimRefIsUnique: Boolean;
    FUserClaimRefValidated: Boolean;
    FPreparedClaimHasClaimableValues: Boolean;

    [async]
    procedure LoadAuthOfficials; async;
    [async]
    procedure SearchForAuthOfficials; async;
    [async]
    procedure CheckForRememberPassword; async;

    procedure PopulateDeclarationText;
    procedure SetAuthorisedOfficial;
    procedure ApplyAuthorisedOfficialState;
    function LoggedInUserCanSubmitHMRCClaim: Boolean;
    [async]
    procedure GetGatewayId; async;
    [async]
    procedure GetDeclarationVersionText; async;
    procedure AddClaimDeclarationTextToMeno(AText: string);
    procedure AddClaimDeclaration;
    procedure MarkLatestSignedDeclarationUsed;
    [async]
    procedure HashClaimDeclaration; async;
    function GetUserName: string;

    [async]
    procedure GetClaimParameters; async;

    procedure UpdateClaimFormForSubmission;
    procedure UpdatePrepareClaimButton;
    function UserClaimRefReady: Boolean;
    procedure ShowPreparedClaimSubmissionStage;
    procedure SetButtonCaption(AButton: TButton; const ACaption: string);
    procedure SetButtonElementState(const AElementId, ACaption: string; AEnabled: Boolean);
    procedure SetButtonState(AButton: TButton; const ACaption: string; AEnabled: Boolean);
    procedure SetClaimParameters(AClaimParameters: TClaimParameters);
    procedure PopulatePrepareGrid(APrepareClaimData: TPrepareClaimData);
    function PreparedClaimHasClaimableValues(APrepareClaimData: TPrepareClaimData): Boolean;
    procedure AddPrepareDataColumn(var ACol: integer; AHeader: string; AValue: Currency);
    procedure NormaliseUserClaimRef;
    [async]
    procedure ValidateUserClaimRefIsUnique; async;
    [async]
    procedure ShowClaimDonations(const AClaimId: Integer); async;
    [async]
    procedure CancelPrepareClaim; async;
    procedure ResetClaim(AClearClaimRef: Boolean = True);

    [async]
    procedure GetPrepareClaimData; async;
    [async]
    procedure GetPrepareClaimPreviewData; async;
    procedure PlacePrepareClaimJob(Sender: TObject);
    procedure PlaceSubmitPreparedClaimJob(Sender: TObject);

    [async]
    procedure ResetPrepareClaim; async;

    [async]
    procedure CheckForOpenPreparedSubmission; async;

    //procedure PrepareButtonEnbled;
  protected
    procedure JobParams(AJobParams: JS.TJSObject); override;
    function MinimumProcessLevel: string; override;
    function JobDescription: string; override;
    function JobDisplayName: string; override;
    function JobClass: string; override;
    function CanPlaceJob: Boolean; override;
    function CloseFormDown: boolean; override;


//    function CheckForMerging;

  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;


implementation

{$R *.dfm}

uses
  MainDataModule,
  XData.Web.Client,
  SMX.Web.Document.Utils,
  jsdelphisystem,
  MainForm,
  XData.Dataset.Utils,
  DonationList;


procedure TGiftAidClaimJob.WebFormCreate(Sender: TObject);
begin
  inherited;
  FUserClaimRef := '';
  SetButtonState(PlaceJobButton, 'Prepare Claim', False);
  AgreeCheckBox.Enabled := False;
  FRememberPasswordEnabled := False;
  OutputOption.Visible := False;
  JobRunType.Visible := False;
  FJobToPlace := cjpPrepareClaim;
  FPrepareDataReviewed := False;
  FPrepareJobCreated := False;
  FUserClaimRefIsUnique := False;
  FUserClaimRefValidated := False;
  FPreparedClaimHasClaimableValues := False;
  CancelPrepareClaimButton.Visible := False;
  CancelPrepareClaimButton.Enabled := False;
  ViewClaimDonationsButton.Visible := False;
  ViewClaimDonationsButton.Enabled := False;
  HMRCPassword.Text := '';
  SetAuthorisedOfficial;
  ApplyAuthorisedOfficialState;

//  GetUnclaimedValues;

  ErrorHandling.LookupValues.AddPair('OmitRecord', 'Omit Record');
  ErrorHandling.LookupValues.AddPair('CancelSubmission', 'Cancel Submission');
  ErrorHandling.ItemIndex := 0;

  HMRCPassword.Text := '';
  CheckForRememberPassword;
  GetClaimParameters;
  InitialCheck.Enabled := True;
//  ResetClaim;

//KSS Below is for the Claim Declaration - commented out until needed
//  GetDeclarationVersionText;
  GetGatewayId;
//KSS Below is for the Claim Declaration - commented out until needed
  CheckForOpenPreparedSubmission;
  UpdatePrepareClaimButton;
  ValidateJob;

//  DisplayClaimDeclaration.Enabled := true;
end;

procedure TGiftAidClaimJob.AgreeCheckBoxClick(Sender: TObject);
begin
  ValidateJob;
end;

procedure TGiftAidClaimJob.AuthOfficialsAfterOpen(Dataset: TDataSet);
begin
  PlaceJobButton.Enabled := False;
  LoadAuthOfficials;
end;

procedure TGiftAidClaimJob.AuthorisedOfficialChange(Sender: TObject);
begin
  inherited;
  CanPlaceJob;
end;

procedure TGiftAidClaimJob.AuthorisedOfficialExit(Sender: TObject);
begin
  inherited;
end;

{ TGiftAidClaimJob }

procedure TGiftAidClaimJob.CancelPrepareClaimButtonClick(Sender: TObject);
begin
  inherited;
  CancelPrepareClaim;
end;

function TGiftAidClaimJob.CanPlaceJob: Boolean;
var
  sPassword: string;

begin
  if not FPrepareJobCreated then
  begin
    result := FPrepareDataReviewed and FPreparedClaimHasClaimableValues and UserClaimRefReady;
    SetButtonState(PlaceJobButton, 'Prepare Claim', result);
    Exit;
  end;

  if not FPreparedClaimHasClaimableValues then
  begin
    SetJobMessage('There are no claimable values remaining. The claim cannot be submitted.');
    SetButtonState(PlaceJobButton, 'Authorise & Submit', False);
    Exit(False);
  end;

  result := True;

  if not LoggedInUserCanSubmitHMRCClaim then
  begin
    AgreeCheckBox.Checked := False;
    AgreeCheckBox.Enabled := False;
    HMRCPassword.Enabled := False;
    SetJobMessage('An authorised user needs to submit this');
    SetButtonState(PlaceJobButton, 'Authorise & Submit', False);
    Exit(False);
  end;

  TDocUtils.setControlValidity(AuthorisedOfficial.ElementID, TValidityState.vsValid);

  if (OutputOption.ItemIndex > -1) then
    TDocUtils.setControlValidity(OutputOption.ElementID, TValidityState.vsValid)
  else
  begin
    TDocUtils.setControlValidity(OutputOption.ElementID, TValidityState.vsInvalid);
    result := result and (not OutputOption.Visible);
  end;

  if (UserClaimRef.Text <> '') and FUserClaimRefValidated and FUserClaimRefIsUnique then
    TDocUtils.setControlValidity(UserClaimRef.ElementID, TValidityState.vsValid)
  else
  begin
    TDocUtils.setControlValidity(UserClaimRef.ElementID, TValidityState.vsInvalid);
    result := result and (not UserClaimRef.Visible);
  end;

  if FRememberPasswordEnabled then
    TDocUtils.setControlValidity(HMRCPassword.ElementID, TValidityState.vSNone)
  else if (HMRCPassword.Text <> '') or FRememberPasswordEnabled then
    TDocUtils.setControlValidity(HMRCPassword.ElementID, TValidityState.vsValid)
  else
  begin
    TDocUtils.setControlValidity(HMRCPassword.ElementID, TValidityState.vsInvalid);
    result := result and (not HMRCPassword.Visible);
  end;


  result := result and (FJobToPlace = cjpSubmitPreparedClaim);

  if result and AgreeCheckBox.Checked then
  begin
    sPassword := HMRCPassword.Text;

    if (sPassword.Trim.IsEmpty) and (FRememberPasswordEnabled = false) then
    begin
      TDocUtils.setControlValidity(HMRCPassword.ElementID, TValidityState.vsInvalid);
      SetJobMessage('You must enter your HMRC Gateway password.');
      SetButtonState(PlaceJobButton, 'Authorise & Submit', False);
      AgreeCheckBox.Checked := False;
      Exit(False);
    end;

    //TDocUtils.setControlValidity(HMRCPassword.ElementID, TwebValidityState.vsValid);

    if result = True then
      SetButtonState(PlaceJobButton, 'Authorise & Submit', True);
  end
  else
  begin
    SetButtonState(PlaceJobButton, 'Authorise & Submit', False);
  end;
end;

procedure TGiftAidClaimJob.ConfigDatasetAfterOpen(Dataset: TDataSet);
const
  _Filter = '$filter=(Status eq ''Active'') and (HMRCValidation eq ''Validated'')';
begin
  inherited;
  AuthOfficials.QueryString := _Filter;
  AuthOfficials.Load;
end;

procedure TGiftAidClaimJob.HMRCPasswordExit(Sender: TObject);
begin
  inherited;
  CanPlaceJob;
end;

function TGiftAidClaimJob.JobClass: string;
begin
  case FJobToPlace of
    cjpPrepareClaim:
      result := 'TPrepareClaimJob';
    cjpSubmitPreparedClaim:
      result := 'TClaimGiftAidJob';
  end;
end;

function TGiftAidClaimJob.JobDescription: string;
begin
  case FJobToPlace of
    cjpPrepareClaim:
      result := 'Preparing Gift Aid claim';
    cjpSubmitPreparedClaim:
      result := 'Submitting prepared Gift Aid claim';
  end;
end;

function TGiftAidClaimJob.JobDisplayName: string;
begin
  result := 'Gift Aid Claim Preparation';
end;

procedure TGiftAidClaimJob.JobParams(AJobParams: JS.TJSObject);
var
  lClaimRef: string;
begin
  inherited;
  NormaliseUserClaimRef;
  lClaimRef := FUserClaimRef;
  if lClaimRef = '' then
    lClaimRef := Uppercase(UserClaimRef.Text.Trim);
  AJobParams.Properties['HMRCPassword'] := HMRCPassword.Text;
  AJobParams.Properties['HMRCOfficial'] := MainData.AppUser.InternalId;
  AJobParams.Properties['ErrorHandling'] := ErrorHandling.Value;
  AJobParams.Properties['ClaimRef'] := lClaimRef;
  AJobParams.Properties['ClaimId'] := FClaimId;

  AJobParams.Properties['ImportId'] := ImportFiles.Value;
  AJobParams.Properties['EarliestClaimDate'] := FormatDateTime('YYYY/MM/DD', OldestDateParameter.Date);
  AJobParams.Properties['LatestClaimDate'] := FormatDateTime('YYYY/MM/DD', NewestDateParameter.Date);
end;

procedure TGiftAidClaimJob.LoadAuthOfficials;
begin
  while not AuthOfficials.Eof do
  begin
    AuthorisedOfficial.LookupValues.AddPair(AuthOfficialsId.AsString, AuthOfficialsFirstName.Value + ' ' +
      AuthOfficialsLastName.Value);
    AuthOfficials.Next;
  end;

  if AuthOfficials.RecordCount = 1 then
    AuthorisedOfficial.ItemIndex := 0
  else
    AuthorisedOfficial.Value := ConfigDatasetHMRCOfficial.AsString;

end;

function TGiftAidClaimJob.MinimumProcessLevel: string;
begin
  result := 'Anyone';//KSS 'AnyAdministrator';
end;

procedure TGiftAidClaimJob.ParameterChange(Sender: TObject);
begin
  FJobToPlace := cjpPrepareClaim;
  FPrepareDataReviewed := False;
  FPrepareJobCreated := False;
  FClaimId := 0;
  UpdatePrepareClaimButton;
  ValidateJob;
end;

procedure TGiftAidClaimJob.PlaceJobButtonClick(Sender: TObject);
begin
  inherited;
//KSS SORT THIS  if assigned(MainPage) then
//    MainPage.DisableSubmissionLink;
end;

procedure TGiftAidClaimJob.PlaceSubmissionJobButtonClick(Sender: TObject);
begin
  if not FPrepareJobCreated then
    PlacePrepareClaimJob(Sender)
  else
    PlaceSubmitPreparedClaimJob(Sender);
end;

procedure TGiftAidClaimJob.PlacePrepareClaimJob(Sender: TObject);
begin
  if not (FPrepareDataReviewed and UserClaimRefReady) then
  begin
    CanPlaceJob;
    Exit;
  end;

  FJobId := 0;
  FPrepareJobCreated := True;
  FJobToPlace := cjpPrepareClaim;
  PrepareClaimButton.Enabled := False;
  PlaceJobButton.Enabled := False;
  PlaceJobButtonClick(Sender);

  AgreeCheckBox.Enabled := False;
  AgreeCheckBox.Checked := False;

  PrepareWaitMessage.Hide;
  PlaceJobManagedExternally := False;
end;

procedure TGiftAidClaimJob.PlaceSubmitPreparedClaimJob(Sender: TObject);
begin
  FJobId := 0;
  FJobToPlace := cjpSubmitPreparedClaim;
  PlaceJobButtonClick(Sender);
  PlaceJobManagedExternally := False;
end;

procedure TGiftAidClaimJob.SearchForAuthOfficials;
var
  lRetval: TXDataClientResponse;
  lResult: JS.TJSObject;

  lList: JS.TJSArray;

  lIdx: Integer;
  lInternalId: Integer;
  lFirstName: string;
  lSecondName: string;
  lUserName: string;
  OffUsers: JS.TJSObject;
begin

  lRetval := await(TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync('IUserManagerService.GetHMRCAuthorisedUsers', [0]));
  lResult := lRetval.ResultAsObject;
  lList := JS.toArray(lResult['value']);

  if lList <> nil then
  begin
    for lIdx := 0 to (lList.Length-1) do
    begin
      OffUsers := JS.toObject(lList.Elements[lIdx]);

      lInternalId := JS.toInteger(OffUsers['InternalId']);
      lFirstName := JS.toString(OffUsers['GivenName']);
      lSecondName := JS.toString(OffUsers['LastName']);

      lUserName := lFirstName + ' ' + lSecondName;
      AuthorisedOfficial.LookupValues.AddPair(inttostr(lInternalId), lUserName);
    end;
  end;

  //It is safe to say there will be an HMRCAuthorisedUser - the form is disabled if there isn't one
  AuthorisedOfficial.ItemIndex := 0;
end;

procedure TGiftAidClaimJob.UserClaimRefChange(Sender: TObject);
begin
  inherited;
  NormaliseUserClaimRef;
  FUserClaimRefValidated := False;
  FUserClaimRefIsUnique := False;
  UpdatePrepareClaimButton;
  CanPlaceJob;
end;

procedure TGiftAidClaimJob.UserClaimRefExit(Sender: TObject);
begin
  inherited;
  NormaliseUserClaimRef;
  ValidateUserClaimRefIsUnique;
end;

procedure TGiftAidClaimJob.CheckForRememberPassword;
var
  lRetval: TXDataClientResponse;
begin
  lRetval := await(TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync('IUserManagerService.HMRCPasswordSavingEnabled', [1]));
  FRememberPasswordEnabled := boolean(TJSObject(lRetval.Result)['value']);

  ApplyAuthorisedOfficialState;
end;

procedure TGiftAidClaimJob.InitialCheckTimer(Sender: TObject);
begin
  InitialCheck.Enabled := False;
  CanPlaceJob;

//KSS  ResetClaim;
end;

function TGiftAidClaimJob.CloseFormDown: boolean;
begin
  if FJobToPlace in [cjpPrepareClaim, cjpSubmitPreparedClaim] then
    result := True
  else
    result := False;
end;

procedure TGiftAidClaimJob.ClaimDeclarationAfterPost(DataSet: TDataSet);
begin
  inherited;
  ClaimDeclaration.ApplyUpdates;
end;

procedure TGiftAidClaimJob.HashClaimDeclaration;
var
  lRetval: TXDataClientResponse;
  lResponse: TJSObject;
  lDeclarationText: string;

begin

  lDeclarationText := DeclarationTextMemo.Lines.Text;

  lRetval := await(TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync('IGiftAiderService.HashDeclaration', [lDeclarationText]));

  lResponse := lRetval.ResultAsObject;
  FDeclarationHash := JS.ToString(lResponse['value']);

end;

procedure TGiftAidClaimJob.SetAuthorisedOfficial;
var
  lAuthorisedOfficial: string;
  lAuthorisedOfficialId: integer;
begin
  lAuthorisedOfficial := GetUserName;
  lAuthorisedOfficialId := MainData.AppUser.InternalId;

  AuthorisedOfficial.LookupValues.AddPair(lAuthorisedOfficialId.ToString, lAuthorisedOfficial);
  AuthorisedOfficial.Value := lAuthorisedOfficialId.ToString;
  AuthorisedOfficial.ItemIndex := 0;
end;

procedure TGiftAidClaimJob.ApplyAuthorisedOfficialState;
var
  lCanSubmitClaim: Boolean;
  lDisplayText: string;
begin
  lCanSubmitClaim := LoggedInUserCanSubmitHMRCClaim;

  if lCanSubmitClaim then
    lDisplayText := GetUserName
  else
    lDisplayText := 'An authorised user needs to submit this';

  asm
    var authorisedOfficialName = document.getElementById('AuthorisedOfficialName');
    if (authorisedOfficialName) {
      authorisedOfficialName.textContent = lDisplayText;
    }

    var authorisedOfficial = document.getElementById('AuthorisedOfficial');
    if (authorisedOfficial) {
      authorisedOfficial.style.display = 'none';
    }
  end;

  if lCanSubmitClaim then
  begin
    if FJobToPlace = cjpSubmitPreparedClaim then
      AgreeCheckBox.Enabled := True;

    HMRCPassword.Enabled := not FRememberPasswordEnabled;
  end
  else
  begin
    AgreeCheckBox.Checked := False;
    AgreeCheckBox.Enabled := False;
    HMRCPassword.Text := '';
    HMRCPassword.Enabled := False;
  end;
end;

function TGiftAidClaimJob.LoggedInUserCanSubmitHMRCClaim: Boolean;
begin
  result := MainData.AppUser.HMRCRegistered;
end;

procedure TGiftAidClaimJob.GetGatewayId;
//var  KSS for claim declaration
//  lRetval: TXDataClientResponse;
begin
//  lRetval := await(TXDataClientResponse,
//    MainData.WebClient.RawInvokeAsync('IUserManagerService.GetGatewayId', [1]));
//  FGatewayId := string(TJSObject(lRetval.Result)['value']);

end;

procedure TGiftAidClaimJob.DisplayClaimDeclarationTimer(Sender: TObject);
begin
  DisplayClaimDeclaration.Enabled := False;
  UserClaimRef.Clear;
  UserClaimRef.ClearSelection;

//KSS Below is for the Claim Declaration - commented out until needed
//  PopulateDeclarationText;
  CanPlaceJob;
end;

procedure TGiftAidClaimJob.PopulateDeclarationText;
var
  lText: string;
  lName: string;
  lTodaysDate: string;
  lCharityName: string;
begin
  lText := FDeclarationVersionText;

  lName := GetUserName;
  lTodaysDate := FormatDateTime('dd/mm/yyyy', Now);
  lCharityName := MainData.OrganisationDisplayName;

  //~ is used as a deliminter in the memo to drop text down to the next line. Used <CRLF> in
  //the text as it is more meaningful to the user
  lText := StringReplace(lText, '<CRLF>', '~', [rfReplaceAll, rfIgnoreCase]);

  lText := StringReplace(lText, '[Full Name]', lName, [rfReplaceAll, rfIgnoreCase]);
  lText := StringReplace(lText, '[Your Gateway ID]', FGatewayId, [rfReplaceAll, rfIgnoreCase]);
  lText := StringReplace(lText, '[Date]', lTodaysDate, [rfReplaceAll, rfIgnoreCase]);

  lText := StringReplace(lText, '[Charity Name]', lCharityName, [rfReplaceAll, rfIgnoreCase]);

//KSS Below is for the Claim Declaration - commented out until needed
//  AddClaimDeclarationTextToMeno(lText);
//KSS Below is for the Claim Declaration - commented out until needed
//  HashClaimDeclaration;
end;

procedure TGiftAidClaimJob.GetDeclarationVersionText;
var
  lRetval: TXDataClientResponse;
begin
  lRetval := await(TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync('IGiftAiderService.GetDeclarationVersionText', []));
  FDeclarationVersionText := string(TJSObject(lRetval.Result)['value']);
end;


procedure TGiftAidClaimJob.AddClaimDeclarationTextToMeno(AText: string);
begin
  DeclarationTextMemo.Clear;
  DeclarationTextMemo.Lines.StrictDelimiter := true;
  DeclarationTextMemo.Lines.Delimiter := '~';
  DeclarationTextMemo.Lines.DelimitedText := AText;
end;

procedure TGiftAidClaimJob.AddClaimDeclaration;
var
  lName: string;
begin
  ClaimDeclaration.Active := True;
  ClaimDeclaration.Insert;
  ClaimDeclaration.FieldByName('ClaimId').AsInteger := FClaimId;
  ClaimDeclaration.FieldByName('DeclarationVersion').AsInteger := 1;
  ClaimDeclaration.FieldByName('DeclarationHash').AsString := FDeclarationHash;
  ClaimDeclaration.FieldByName('DeclarationIssueDate').AsDateTime := Now;
  ClaimDeclaration.FieldByName('DeclarationExpiryDate').AsDateTime := Now + 10;
  ClaimDeclaration.FieldByName('DeclarationSignedDate').AsDateTime := Now;
  ClaimDeclaration.FieldByName('DeclarationSignedByUser').AsInteger := MainData.AppUser.InternalId;
  ClaimDeclaration.FieldByName('DeclarationByName').AsString := GetUserName;
  ClaimDeclaration.FieldByName('DeclarationSigningChannel').AsString := 'GiftAider';
  ClaimDeclaration.FieldByName('DeclarationStatus').AsString := 'Signed';
  ClaimDeclaration.FieldByName('SignedDeclarationText').AsString := DeclarationTextMemo.Lines.Text;
  ClaimDeclaration.Post;
end;

procedure TGiftAidClaimJob.MarkLatestSignedDeclarationUsed;
var
  lLatestDeclarationId: Integer;
begin
  lLatestDeclarationId := 0;
  ClaimDeclaration.Active := True;
  ClaimDeclaration.First;
  while not ClaimDeclaration.Eof do
  begin
    if (ClaimDeclarationClaimId.AsInteger = FClaimId) and
      SameText(ClaimDeclarationDeclarationStatus.AsString, 'Signed') and
      (ClaimDeclarationId.AsInteger > lLatestDeclarationId) then
      lLatestDeclarationId := ClaimDeclarationId.AsInteger;
    ClaimDeclaration.Next;
  end;

  if (lLatestDeclarationId > 0) and ClaimDeclaration.Locate('Id', lLatestDeclarationId, []) then
  begin
    ClaimDeclaration.Edit;
    ClaimDeclarationDeclarationStatus.AsString := 'Used';
    ClaimDeclaration.Post;
  end;
end;

function TGiftAidClaimJob.GetUserName: string;
begin
  result := MainData.AppUser.GivenName + ' ' + MainData.AppUser.LastName;
end;


(*
procedure TGiftAidClaimJob.GetPrepareClaimId;
var
  lRetval: TXDataClientResponse;
  lPrepareClaimData: TPrepareClaimData;
  lResponse: TJSObject;
  lClaimId: integer;
begin
  lRetval := await(TXDataClientResponse,                          //check JobId
    MainData.WebClient.RawInvokeAsync('IGiftAiderService.GetPrepareClaimId', [FJobId]));

  FClaimId := JS.ToInteger(lRetval.ResultAsObject['value']);

  //FClaimId := lRetval.AsInteger;
  //lPrepareClaimData := TPrepareClaimData.Create;
  //lPrepareClaimData.Assign(lResponse);

  //PopulatePrepareGrid(lPrepareClaimData);
  // KSS PrepareWaitMessage.Hide;

end;*)

procedure TGiftAidClaimJob.GetPrepareClaimData;
var
  lRetval: TXDataClientResponse;
  lPrepareClaimData: TPrepareClaimData;
  lResponse: TJSObject;
begin
//  lRetval := await(TXDataClientResponse,
//    MainData.WebClient.RawInvokeAsync('IGiftAiderService.PrepareClaimData', [FClaimId]));
  lRetval := await(TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync('IGiftAiderService.PrepareClaimData', [FJobId]));

  lResponse := lRetval.ResultAsObject;
  lPrepareClaimData := TPrepareClaimData.Create;
  lPrepareClaimData.Assign(lResponse);

  if lPrepareClaimData.Complete then
    PrepareWaitMessage.Hide;

  PopulatePrepareGrid(lPrepareClaimData);
end;

procedure TGiftAidClaimJob.GetPrepareClaimPreviewData;
var
  lRetval: TXDataClientResponse;
  lPrepareClaimData: TPrepareClaimData;
  lResponse: TJSObject;
begin
  lRetval := await(TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync('IGiftAiderService.PrepareClaimDataDirect',
      [StrToIntDef(ImportFiles.Value, 0), OldestDateParameter.Date, NewestDateParameter.Date]));

  lResponse := lRetval.ResultAsObject;
  lPrepareClaimData := TPrepareClaimData.Create;
  lPrepareClaimData.Assign(lResponse);

  PrepareWaitMessage.Hide;
  FPrepareDataReviewed := True;
  FPrepareJobCreated := False;

  PopulatePrepareGrid(lPrepareClaimData);
end;

procedure TGiftAidClaimJob.PrepareClaimButtonClick(Sender: TObject);
begin
  if ImportFiles.ItemIndex = -1 then
    Exit;

  ResetClaim(False);
  PrepareWaitMessage.Show;
  GetPrepareClaimPreviewData;
end;

procedure TGiftAidClaimJob.PrepareClaimTimerTimer(Sender: TObject);
begin
  PrepareClaimTimer.Interval := 10000;

  if FJobId <> 0 then
    GetPrepareClaimData;

 //if FClaimId <> 0 then  //KSS Delete this when happy
 //   PrepareClaimTimer.Enabled := False;
 //  GetPrepareClaimData;
end;

procedure TGiftAidClaimJob.PopulatePrepareGrid(APrepareClaimData: TPrepareClaimData);
var
  lCol: integer;
  
begin
  FClaimId := APrepareClaimData.ClaimId;
  FPreparedClaimHasClaimableValues := PreparedClaimHasClaimableValues(APrepareClaimData);
  ViewClaimDonationsButton.Visible := FPrepareJobCreated and (FClaimId <> 0);
  ViewClaimDonationsButton.Enabled := ViewClaimDonationsButton.Visible;

  PrepareClaimData.RowCount := 2;
  PrepareClaimData.ColCount := 1;
  PrepareClaimData.Cells[0,0] := 'Donation Count';
  PrepareClaimData.Cells[0,1] := inttostr(APrepareClaimData.DonationCount);
  lCol := 1; //Current
  AddPrepareDataColumn(lCol, 'Amount', APrepareClaimData.Amount);
  AddPrepareDataColumn(lCol, 'Gift Aid', APrepareClaimData.GiftAid);

  AddPrepareDataColumn(lCol, 'GASDS', APrepareClaimData.GASDS);
  AddPrepareDataColumn(lCol, 'GASDS Adj.', APrepareClaimData.GASDSAdjustments);
  AddPrepareDataColumn(lCol, 'Aggregated', APrepareClaimData.AggregatedDonations);
  AddPrepareDataColumn(lCol, 'Other Inc.', APrepareClaimData.OtherIncome);
  AddPrepareDataColumn(lCol, 'Adj.', APrepareClaimData.Adjustments);
  AddPrepareDataColumn(lCol, 'Comm. Build', APrepareClaimData.CommunityBuildings);

  if APrepareClaimData.Complete then
  begin
    PrepareClaimTimer.Enabled := False;
    PrepareWaitMessage.Hide;
    if FPrepareJobCreated then
      UpdateClaimFormForSubmission
    else
      UpdatePrepareClaimButton;
  end
  else
    PrepareClaimTimer.Enabled := True;
end;

function TGiftAidClaimJob.PreparedClaimHasClaimableValues(APrepareClaimData: TPrepareClaimData): Boolean;
begin
  Result := (APrepareClaimData.GiftAid > 0) or
    (APrepareClaimData.GASDS > 0) or
    (APrepareClaimData.AggregatedDonations > 0) or
    (APrepareClaimData.OtherIncome > 0) or
    (APrepareClaimData.GASDSAdjustments > 0) or
    (APrepareClaimData.CommunityBuildings > 0);
end;

procedure TGiftAidClaimJob.AddPrepareDataColumn(var ACol: integer; AHeader: string; AValue: Currency);
begin
  if AValue <> 0.00 then
  begin
    inc(ACol);
    PrepareClaimData.ColCount := ACol;
    PrepareClaimData.Cells[ACol-1,0] := AHeader;
    PrepareClaimData.Cells[ACol-1,1] := format('%0.2f', [AValue]);
  end;
end;

procedure TGiftAidClaimJob.NormaliseUserClaimRef;
var
  lUserClaimRef: string;
begin
  lUserClaimRef := UpperCase(UserClaimRef.Text);
  UserClaimRef.Text := lUserClaimRef;
  FUserClaimRef := lUserClaimRef.Trim;
end;

procedure TGiftAidClaimJob.ValidateUserClaimRefIsUnique;
var
  lRetval: TXDataClientResponse;
  lClaimRef: string;
begin
  NormaliseUserClaimRef;
  lClaimRef := UserClaimRef.Text.Trim;
  FUserClaimRefValidated := lClaimRef <> '';
  FUserClaimRefIsUnique := False;

  if FUserClaimRefValidated then
  begin
    lRetval := await(TXDataClientResponse,
      MainData.WebClient.RawInvokeAsync('IGiftAiderService.ClaimRefIsUnique', [lClaimRef, FClaimId]));
    FUserClaimRefIsUnique := Boolean(TJSObject(lRetval.Result)['value']);
  end;

  if FUserClaimRefIsUnique then
  begin
    TDocUtils.setControlValidity(UserClaimRef.ElementID, TValidityState.vsValid);
    ClearJobMessage;
  end
  else
  begin
    TDocUtils.setControlValidity(UserClaimRef.ElementID, TValidityState.vsInvalid);
    if lClaimRef <> '' then
      SetJobMessage('This claim reference has already been used.');
  end;

  CanPlaceJob;
end;

procedure TGiftAidClaimJob.GetClaimParameters;
var
  lRetval: TXDataClientResponse;
  lClaimParameters: TClaimParameters;
  lResponse: TJSObject;

begin
  lRetval := await(TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync('IGiftAiderService.GetClaimParameters', []));

  lResponse := lRetval.ResultAsObject;
  lClaimParameters := TClaimParameters.Create;
  lClaimParameters.Assign(lResponse);

  SetClaimParameters(lClaimParameters);
end;

procedure TGiftAidClaimJob.UpdateClaimFormForSubmission;
begin
  SetButtonState(PrepareClaimButton, 'Evaluate Claim', False);
  FJobToPlace := cjpSubmitPreparedClaim;
  ApplyAuthorisedOfficialState;
  CancelPrepareClaimButton.Enabled := False;
  CancelPrepareClaimButton.Visible := False;
  ViewClaimDonationsButton.Visible := FClaimId <> 0;
  ViewClaimDonationsButton.Enabled := ViewClaimDonationsButton.Visible;
  SetButtonState(PlaceJobButton, 'Authorise & Submit', False);
  ValidateJob;
end;

procedure TGiftAidClaimJob.ShowPreparedClaimSubmissionStage;
begin
  {$IFDEF PAS2JS}
  asm
    var root = document.querySelector('.smxGiftAidClaimForm');
    if (root) {
      var stage1 = root.querySelector('.claim-stage-1');
      var stage2 = root.querySelector('.claim-stage-2');
      var stage3 = root.querySelector('.claim-stage-3');
      var nav1 = root.querySelector('#claimWizardNav1');
      var nav2 = root.querySelector('#claimWizardNav2');
      var nav3 = root.querySelector('#claimWizardNav3');
      var back1 = root.querySelector('#WizardBackToStep1');
      var back2 = root.querySelector('#WizardBackToStep2');
      var next2 = root.querySelector('#WizardContinueToStep2');
      var next3 = root.querySelector('#WizardContinueToStep3');
      var placeJob = root.querySelector('#PlaceJobButton');
      var claimGrid = root.querySelector('#PrepareClaimData');

      if (stage1) {
        stage1.classList.remove('is-active');
        stage1.style.display = 'none';
      }
      if (stage2) {
        stage2.classList.remove('is-active');
        stage2.style.display = 'none';
      }
      if (stage3) {
        stage3.classList.add('is-active');
        stage3.style.display = '';

        var stage3Right = stage3.querySelector('.col-8');
        if (stage3Right && claimGrid && !root.querySelector('#PreparedClaimSummary')) {
          var summary = document.createElement('div');
          summary.id = 'PreparedClaimSummary';
          summary.className = 'pb-2 mt-3';
          summary.innerHTML = '<h5 class="fw-semibold text-secondary pb-2">Prepared Claim</h5>';
          summary.appendChild(claimGrid);
          stage3Right.insertBefore(summary, stage3Right.firstChild);
        }
      }

      if (nav1) {
        nav1.style.display = 'none';
        nav1.classList.remove('is-active');
      }
      if (nav2) {
        nav2.style.display = 'none';
        nav2.classList.remove('is-active');
      }
      if (nav3) {
        nav3.classList.add('is-active');
        nav3.innerHTML = '<span class="claim-step-number">2.</span> Submit Prepared Claim';
        nav3.onclick = function () { return false; };
      }

      if (back1) {
        back1.style.display = 'none';
      }
      if (back2) {
        back2.style.display = 'none';
      }
      if (next2) {
        next2.style.display = 'none';
      }
      if (next3) {
        next3.style.display = 'none';
        next3.disabled = true;
        next3.setAttribute('disabled', 'disabled');
      }
      if (placeJob) {
        placeJob.style.display = 'inline-block';
      }

      if (window.smxSyncGiftAidClaimState) {
        window.smxSyncGiftAidClaimState(root);
      }
    }
  end;
  {$ENDIF}
end;

procedure TGiftAidClaimJob.UpdatePrepareClaimButton;
begin
  if FPrepareJobCreated then
  begin
    {$IFDEF PAS2JS}
    asm
      var placeJobButton = document.getElementById('PlaceJobButton');
      if (placeJobButton) {
        placeJobButton.removeAttribute('data-prepare-visible');
      }
    end;
    {$ENDIF}
    FJobToPlace := cjpSubmitPreparedClaim;
    ApplyAuthorisedOfficialState;
    ViewClaimDonationsButton.Visible := FClaimId <> 0;
    ViewClaimDonationsButton.Enabled := ViewClaimDonationsButton.Visible;
    SetButtonState(PrepareClaimButton, 'Evaluate Claim', False);
    SetButtonState(PlaceJobButton, 'Authorise & Submit', False);
  end
  else if FPrepareDataReviewed then
  begin
    {$IFDEF PAS2JS}
    asm
      var placeJobButton = document.getElementById('PlaceJobButton');
      if (placeJobButton) {
        placeJobButton.setAttribute('data-prepare-visible', 'true');
      }
    end;
    {$ENDIF}
    SetButtonState(PrepareClaimButton, 'Evaluate Claim', False);
    ViewClaimDonationsButton.Visible := False;
    ViewClaimDonationsButton.Enabled := False;
    SetButtonState(PlaceJobButton, 'Prepare Claim', UserClaimRefReady);
  end
  else
  begin
    {$IFDEF PAS2JS}
    asm
      var placeJobButton = document.getElementById('PlaceJobButton');
      if (placeJobButton) {
        placeJobButton.removeAttribute('data-prepare-visible');
      }
    end;
    {$ENDIF}
    SetButtonState(PrepareClaimButton, 'Evaluate Claim', True);
    ViewClaimDonationsButton.Visible := False;
    ViewClaimDonationsButton.Enabled := False;
    SetButtonState(PlaceJobButton, 'Prepare Claim', False);
  end;
end;

function TGiftAidClaimJob.UserClaimRefReady: Boolean;
begin
  Result := (UserClaimRef.Text.Trim <> '') and FUserClaimRefValidated and FUserClaimRefIsUnique;

  if Result then
    TDocUtils.setControlValidity(UserClaimRef.ElementID, TValidityState.vsValid)
  else if UserClaimRef.Visible then
    TDocUtils.setControlValidity(UserClaimRef.ElementID, TValidityState.vsInvalid);
end;

procedure TGiftAidClaimJob.ShowClaimDonations(const AClaimId: Integer);
var
  lForm: TDonations_List;
begin
  if AClaimId = 0 then
    Exit;

  lForm := TDonations_List.Create(Self);
  try
    lForm.Popup := True;
    lForm.PopupOpacity := 1;
    lForm.ElementClassName := 'PopUpForm';
    await(TForm, lForm.Load());
    lForm.ClaimId := AClaimId;
    lForm.AfterCreated;
    await(TModalResult, lForm.Execute);
    if FPrepareJobCreated and (FClaimId <> 0) then
      await(CheckForOpenPreparedSubmission);
  finally
    lForm.Free;
    lForm := nil;
  end;
end;

procedure TGiftAidClaimJob.ViewClaimDonationsButtonClick(Sender: TObject);
begin
  await(ShowClaimDonations(FClaimId));
end;

procedure TGiftAidClaimJob.SetButtonCaption(AButton: TButton; const ACaption: string);
begin
  AButton.Caption := ACaption;
  if AButton.ElementID <> '' then
  begin
    TDocUtils.writeElementText(AButton.ElementID, ACaption);
    AButton.ElementHandle.setAttribute('aria-label', ACaption);
  end;
end;

procedure TGiftAidClaimJob.SetButtonElementState(const AElementId, ACaption: string; AEnabled: Boolean);
begin
  {$IFDEF PAS2JS}
  asm
    var buttonElement = document.getElementById(AElementId);
    if (buttonElement) {
      buttonElement.textContent = ACaption;
      buttonElement.setAttribute('aria-label', ACaption);
      buttonElement.disabled = !AEnabled;
      if (AEnabled) {
        buttonElement.removeAttribute('disabled');
      } else {
        buttonElement.setAttribute('disabled', 'disabled');
      }
      if (AElementId === 'PlaceJobButton' && ACaption === 'Prepare Claim') {
        buttonElement.style.display = buttonElement.getAttribute('data-prepare-visible') === 'true' ? 'inline-block' : 'none';
      }
      var root = buttonElement.closest('.smxGiftAidClaimForm');
      if (root && window.smxSyncGiftAidClaimState) {
        window.smxSyncGiftAidClaimState(root);
      }
    }
  end;
  {$ENDIF}
end;

procedure TGiftAidClaimJob.SetButtonState(AButton: TButton; const ACaption: string; AEnabled: Boolean);
begin
  AButton.Enabled := AEnabled;
  SetButtonCaption(AButton, ACaption);
  if AButton.ElementID <> '' then
  begin
    if AEnabled then
      AButton.ElementHandle.removeAttribute('disabled')
    else
      AButton.ElementHandle.setAttribute('disabled', 'disabled');
  end;

  if AButton = PlaceJobButton then
    SetButtonElementState('PlaceJobButton', ACaption, AEnabled);
end;

procedure TGiftAidClaimJob.SetClaimParameters(AClaimParameters: TClaimParameters);
var
  lOldestDate, lNewestDate: TDate;
  lIdx: integer;
  lImportFileNames: TStringList;
  lImportIds: TStringList;
  lImportFileName: string;
  lImportId: string;

begin
  lImportFileNames := TStringList.Create;
  lImportFileNames.StrictDelimiter := True;
  lImportFileNames.CommaText := AClaimParameters.ImportFiles;
  lImportIds := TStringList.Create;
  lImportIds.StrictDelimiter := True;
  lImportIds.CommaText := AClaimParameters.ImportIds;

  try
    for lIdx := 0  to lImportFileNames.Count-1 do
    begin
      lImportFileName := lImportFileNames[lIdx];
      lImportId := lImportIds[lIdx];
      ImportFiles.LookupValues.AddPair(lImportId, lImportFileName);
    end;

    if lIdx > -1 then
      ImportFiles.ItemIndex := 0;

    lOldestDate := strtodate(AClaimParameters.OldestDate);
    lNewestDate := strtodate(AClaimParameters.NewestDate);

  finally
    lImportFileNames.Free;
    lImportIds.Free;
  end;
  OldestDateParameter.Date := lOldestDate;
  NewestDateParameter.Date := lNewestDate;
end;

procedure TGiftAidClaimJob.CancelPrepareClaim;
begin
  if FPrepareJobCreated and (FClaimId <> 0) then
    ResetPrepareClaim;
  ResetClaim;
end;

procedure TGiftAidClaimJob.ResetClaim(AClearClaimRef: Boolean = True);
var
  lIdx: Integer;
begin
  for lIdx := 1 to PrepareClaimData.ColCount-1 do
  begin
    PrepareClaimData.Cells[lIdx,0] := '';
    PrepareClaimData.Cells[lIdx,1] := '';
  end;

  PrepareClaimData.ColCount := 3;
  PrepareClaimData.Cells[0,0] := 'Donation Count';
  PrepareClaimData.Cells[0,1] := '0';
  PrepareClaimData.Cells[1,0] := 'Amount';
  PrepareClaimData.Cells[1,1] := '0.00';
  PrepareClaimData.Cells[2,0] := 'GiftAid';
  PrepareClaimData.Cells[2,1] := '0.00';

  CancelPrepareClaimButton.Enabled := False;
  CancelPrepareClaimButton.Visible := False;
  PrepareClaimButton.Caption := 'Evaluate Claim';
  if AClearClaimRef then
  begin
    UserClaimRef.Text := '';
    UserClaimRef.Clear;
    UserClaimRef.ClearSelection;
    FUserClaimRef := '';
    FUserClaimRefIsUnique := False;
    FUserClaimRefValidated := False;
  end;
  UserClaimRef.Enabled := True;
  FJobToPlace := cjpPrepareClaim;
  FPrepareDataReviewed := False;
  FPrepareJobCreated := False;
  FPreparedClaimHasClaimableValues := False;
  ViewClaimDonationsButton.Visible := False;
  ViewClaimDonationsButton.Enabled := False;
  FJobId := 0;
  FClaimId := 0;
  UpdatePrepareClaimButton;
end;

procedure TGiftAidClaimJob.ResetPrepareClaim;
var

begin
  await(TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync('IGiftAiderService.ResetPrepareClaim', [FClaimId]));

end;

procedure TGiftAidClaimJob.CheckForOpenPreparedSubmission;
var
  lRetval: TXDataClientResponse;
  lRetrievePreparedClaim: TRetrievePreparedClaim;
  lPrepareClaimData: TPrepareClaimData;
  lResponse: TJSObject;
  lOldestDate, lNewestDate: TDate;

begin
  lRetval := await(TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync('IGiftAiderService.RetrievePreparedClaim', []));

  lResponse := lRetval.ResultAsObject;
  lRetrievePreparedClaim := TRetrievePreparedClaim.Create;
  lRetrievePreparedClaim.Assign(lResponse);


  if lRetrievePreparedClaim.Exists = True then
  begin
    FPrepareDataReviewed := True;
    FPrepareJobCreated := True;
    lOldestDate:= strtodate(lRetrievePreparedClaim.OldestDate);
    lNewestDate:= strtodate(lRetrievePreparedClaim.NewestDate);

    OldestDateParameter.Date := lOldestDate;
    NewestDateParameter.Date := lNewestDate;

    ImportFiles.Value := lRetrievePreparedClaim.ImportId;
    FClaimId := lRetrievePreparedClaim.ClaimId;

    if lRetrievePreparedClaim.ClaimRef <> '' then
    begin
      FUserClaimRef := lRetrievePreparedClaim.ClaimRef.ToUpper;
      UserClaimRef.Text := FUserClaimRef;
      ValidateUserClaimRefIsUnique;
    end;

    JobId := lRetrievePreparedClaim.PrepareJobId;

    lPrepareClaimData := TPrepareClaimData.Create;

    lPrepareClaimData.Complete := True;
    lPrepareClaimData.ClaimId := lRetrievePreparedClaim.ClaimId;
    lPrepareClaimData.DonationCount := lRetrievePreparedClaim.DonationCount;
    lPrepareClaimData.Amount := lRetrievePreparedClaim.Amount;
    lPrepareClaimData.GiftAid := lRetrievePreparedClaim.GiftAid;
    lPrepareClaimData.GASDS := lRetrievePreparedClaim.GASDS;
    lPrepareClaimData.AggregatedDonations := lRetrievePreparedClaim.AggregatedDonations;
    lPrepareClaimData.OtherIncome := lRetrievePreparedClaim.OtherIncome;
    lPrepareClaimData.GASDSAdjustments := lRetrievePreparedClaim.GASDSAdjustments;
    lPrepareClaimData.Adjustments := lRetrievePreparedClaim.Adjustments;
    lPrepareClaimData.CommunityBuildings := lRetrievePreparedClaim.CommunityBuildings;

    PopulatePrepareGrid(lPrepareClaimData);
    ShowPreparedClaimSubmissionStage;
  end
  else
  begin
    if FPrepareJobCreated and (FClaimId <> 0) then
    begin
      ResetClaim;
      SetJobMessage('The prepared claim has been cancelled because there are no claimable values remaining.');
    end
    else
    UserClaimRef.Text := '';
  end;
end;


procedure TGiftAidClaimJob.LoadDFMValues;
begin
  inherited LoadDFMValues;

  AgreeCheckBox := TCheckBox.Create('AgreeCheckBox');
  AuthorisedOfficial := TLookupComboBox.Create('AuthorisedOfficial');
  ErrorHandling := TLookupComboBox.Create('ErrorHandling');
  HMRCPassword := TEdit.Create('HMRCPassword');
  UserClaimRef := TEdit.Create('UserClaimRef');
  PrepareClaimDataXXX := TTableControl.Create('PrepareClaimDataXXX');
  OldestDateParameter := TDateTimePicker.Create('OldestDateParameter');
  NewestDateParameter := TDateTimePicker.Create('NewestDateParameter');
  ImportFiles := TLookupComboBox.Create('ImportReference');
  PrepareWaitMessage := TWaitMessage.Create(Self);
  CancelPrepareClaimButton := TButton.Create('CancelPrepareClaimButton');
  PrepareClaimButton := TButton.Create('PrepareClaimButton');
  DeclarationTextMemo := TMemo.Create('DeclarationTextMemo');
  PrepareClaimData := TTableControl.Create('PrepareClaimData');
  ViewClaimDonationsButton := TButton.Create('ViewClaimDonationsButton');
  JobsPlacedDateAdded := TDateTimeField.Create(Self);
  JobsPlacedAddedBy := TIntegerField.Create(Self);
  JobsPlacedLastUpdatedBy := TIntegerField.Create(Self);
  JobsPlacedLastUpdated := TDateTimeField.Create(Self);
  JobsPlacedJobCategory := TStringField.Create(Self);
  JobsPlacedLastPolled := TDateTimeField.Create(Self);
  JobsPlacedPollInterval := TLargeintField.Create(Self);
  JobsPlacedPollCount := TIntegerField.Create(Self);
  AuthOfficials := TXDataWebDataSet.Create(Self);
  AuthOfficialsId := TIntegerField.Create(Self);
  AuthOfficialsFirstName := TStringField.Create(Self);
  AuthOfficialsLastName := TStringField.Create(Self);
  ConfigDataset := TXDataWebDataSet.Create(Self);
  ConfigDatasetId := TIntegerField.Create(Self);
  ConfigDatasetHMRCOfficial := TIntegerField.Create(Self);
  ConfigDatasetCharityRef := TStringField.Create(Self);
  ConfigDatasetCharityType := TStringField.Create(Self);
  ConfigDatasetGatewayId := TStringField.Create(Self);
  ConfigDatasetGatewayPassword := TStringField.Create(Self);
  ConfigDatasetRegulator := TStringField.Create(Self);
  ConfigDatasetRegulatorNumber := TStringField.Create(Self);
  ConfigDatasetEndOfYear := TStringField.Create(Self);
  ConfigDatasetOrganisationType := TStringField.Create(Self);
  ConfigDatasetOrganisationName := TStringField.Create(Self);
  ConfigDatasetSubmissionMethod := TStringField.Create(Self);
  GAUsers := TClientDataSet.Create(Self);
  InitialCheck := TTimer.Create(Self);
  DisplayClaimDeclaration := TTimer.Create(Self);
  ClaimDeclaration := TXDataWebDataSet.Create(Self);
  ClaimDeclarationId := TIntegerField.Create(Self);
  ClaimDeclarationDateAdded := TDateTimeField.Create(Self);
  ClaimDeclarationAddedBy := TIntegerField.Create(Self);
  ClaimDeclarationLastUpdatedBy := TIntegerField.Create(Self);
  ClaimDeclarationLastUpdated := TDateTimeField.Create(Self);
  ClaimDeclarationClaimId := TIntegerField.Create(Self);
  ClaimDeclarationDeclarationVersion := TIntegerField.Create(Self);
  ClaimDeclarationDeclarationHash := TStringField.Create(Self);
  ClaimDeclarationDeclarationIssueDate := TDateTimeField.Create(Self);
  ClaimDeclarationDeclarationExpiryDate := TDateTimeField.Create(Self);
  ClaimDeclarationDeclarationSignedDate := TDateTimeField.Create(Self);
  ClaimDeclarationDeclarationSignedByUser := TIntegerField.Create(Self);
  ClaimDeclarationDeclarationByName := TStringField.Create(Self);
  ClaimDeclarationDeclarationSigningChannel := TStringField.Create(Self);
  ClaimDeclarationDeclarationStatus := TStringField.Create(Self);
  ClaimDeclarationSignedDeclarationText := TStringField.Create(Self);
  PrepareClaimTimer := TTimer.Create(Self);

  JobsPlacedTable.BeforeLoadDFMValues;
  CancelButton.BeforeLoadDFMValues;
  PlaceJobButton.BeforeLoadDFMValues;
  OutputOption.BeforeLoadDFMValues;
  JobVisibility.BeforeLoadDFMValues;
  WaitMessage.BeforeLoadDFMValues;
  JobRunType.BeforeLoadDFMValues;
  AgreeCheckBox.BeforeLoadDFMValues;
  AuthorisedOfficial.BeforeLoadDFMValues;
  ErrorHandling.BeforeLoadDFMValues;
  HMRCPassword.BeforeLoadDFMValues;
  UserClaimRef.BeforeLoadDFMValues;
  PrepareClaimDataXXX.BeforeLoadDFMValues;
  OldestDateParameter.BeforeLoadDFMValues;
  NewestDateParameter.BeforeLoadDFMValues;
  ImportFiles.BeforeLoadDFMValues;
  PrepareWaitMessage.BeforeLoadDFMValues;
  CancelPrepareClaimButton.BeforeLoadDFMValues;
  PrepareClaimButton.BeforeLoadDFMValues;
  DeclarationTextMemo.BeforeLoadDFMValues;
  PrepareClaimData.BeforeLoadDFMValues;
  ViewClaimDonationsButton.BeforeLoadDFMValues;
  JobsPlaced.BeforeLoadDFMValues;
  JobsPlacedDateAdded.BeforeLoadDFMValues;
  JobsPlacedAddedBy.BeforeLoadDFMValues;
  JobsPlacedLastUpdatedBy.BeforeLoadDFMValues;
  JobsPlacedLastUpdated.BeforeLoadDFMValues;
  JobsPlacedJobCategory.BeforeLoadDFMValues;
  JobsPlacedLastPolled.BeforeLoadDFMValues;
  JobsPlacedPollInterval.BeforeLoadDFMValues;
  JobsPlacedPollCount.BeforeLoadDFMValues;
  CloseTimer.BeforeLoadDFMValues;
  AuthOfficials.BeforeLoadDFMValues;
  AuthOfficialsId.BeforeLoadDFMValues;
  AuthOfficialsFirstName.BeforeLoadDFMValues;
  AuthOfficialsLastName.BeforeLoadDFMValues;
  ConfigDataset.BeforeLoadDFMValues;
  ConfigDatasetId.BeforeLoadDFMValues;
  ConfigDatasetHMRCOfficial.BeforeLoadDFMValues;
  ConfigDatasetCharityRef.BeforeLoadDFMValues;
  ConfigDatasetCharityType.BeforeLoadDFMValues;
  ConfigDatasetGatewayId.BeforeLoadDFMValues;
  ConfigDatasetGatewayPassword.BeforeLoadDFMValues;
  ConfigDatasetRegulator.BeforeLoadDFMValues;
  ConfigDatasetRegulatorNumber.BeforeLoadDFMValues;
  ConfigDatasetEndOfYear.BeforeLoadDFMValues;
  ConfigDatasetOrganisationType.BeforeLoadDFMValues;
  ConfigDatasetOrganisationName.BeforeLoadDFMValues;
  ConfigDatasetSubmissionMethod.BeforeLoadDFMValues;
  GAUsers.BeforeLoadDFMValues;
  InitialCheck.BeforeLoadDFMValues;
  DisplayClaimDeclaration.BeforeLoadDFMValues;
  ClaimDeclaration.BeforeLoadDFMValues;
  ClaimDeclarationId.BeforeLoadDFMValues;
  ClaimDeclarationDateAdded.BeforeLoadDFMValues;
  ClaimDeclarationAddedBy.BeforeLoadDFMValues;
  ClaimDeclarationLastUpdatedBy.BeforeLoadDFMValues;
  ClaimDeclarationLastUpdated.BeforeLoadDFMValues;
  ClaimDeclarationClaimId.BeforeLoadDFMValues;
  ClaimDeclarationDeclarationVersion.BeforeLoadDFMValues;
  ClaimDeclarationDeclarationHash.BeforeLoadDFMValues;
  ClaimDeclarationDeclarationIssueDate.BeforeLoadDFMValues;
  ClaimDeclarationDeclarationExpiryDate.BeforeLoadDFMValues;
  ClaimDeclarationDeclarationSignedDate.BeforeLoadDFMValues;
  ClaimDeclarationDeclarationSignedByUser.BeforeLoadDFMValues;
  ClaimDeclarationDeclarationByName.BeforeLoadDFMValues;
  ClaimDeclarationDeclarationSigningChannel.BeforeLoadDFMValues;
  ClaimDeclarationDeclarationStatus.BeforeLoadDFMValues;
  ClaimDeclarationSignedDeclarationText.BeforeLoadDFMValues;
  PrepareClaimTimer.BeforeLoadDFMValues;
  try
    JobsPlacedTable.Top := 8;
    CancelButton.Left := 414;
    PlaceJobButton.Caption := 'Prepare Claim';
    PlaceJobButton.Enabled := False;
    SetEvent(PlaceJobButton, Self, 'OnClick', 'PlaceSubmissionJobButtonClick');
    OutputOption.Top := 263;
    JobVisibility.Visible := False;
    WaitMessage.Left := 104;
    WaitMessage.Top := 425;
    JobRunType.Visible := False;
    AgreeCheckBox.SetParentComponent(Self);
    AgreeCheckBox.Name := 'AgreeCheckBox';
    AgreeCheckBox.Left := 64;
    AgreeCheckBox.Top := 350;
    AgreeCheckBox.Width := 113;
    AgreeCheckBox.Height := 22;
    AgreeCheckBox.Caption := 'I Agree';
    AgreeCheckBox.ChildOrder := 10;
    AgreeCheckBox.ElementClassName := 'custom-control custom-checkbox';
    AgreeCheckBox.ElementButtonClassName := 'from-control-input';
    AgreeCheckBox.ElementLabelClassName := 'form-control-label';
    AgreeCheckBox.ElementFont := efCSS;
    AgreeCheckBox.ElementPosition := epIgnore;
    AgreeCheckBox.Enabled := False;
    AgreeCheckBox.HeightStyle := ssAuto;
    AgreeCheckBox.HeightPercent := 100.000000000000000000;
    AgreeCheckBox.WidthStyle := ssAuto;
    AgreeCheckBox.WidthPercent := 100.000000000000000000;
    SetEvent(AgreeCheckBox, Self, 'OnClick', 'AgreeCheckBoxClick');
    AuthorisedOfficial.SetParentComponent(Self);
    AuthorisedOfficial.Name := 'AuthorisedOfficial';
    AuthorisedOfficial.Left := 352;
    AuthorisedOfficial.Top := 378;
    AuthorisedOfficial.Width := 249;
    AuthorisedOfficial.Height := 22;
    AuthorisedOfficial.ElementClassName := 'form-select';
    AuthorisedOfficial.ElementFont := efCSS;
    AuthorisedOfficial.HeightPercent := 100.000000000000000000;
    AuthorisedOfficial.WidthPercent := 100.000000000000000000;
    SetEvent(AuthorisedOfficial, Self, 'OnChange', 'AuthorisedOfficialChange');
    SetEvent(AuthorisedOfficial, Self, 'OnExit', 'AuthorisedOfficialExit');
    AuthorisedOfficial.ItemIndex := -1;
    ErrorHandling.SetParentComponent(Self);
    ErrorHandling.Name := 'ErrorHandling';
    ErrorHandling.Left := 63;
    ErrorHandling.Top := 380;
    ErrorHandling.Width := 249;
    ErrorHandling.Height := 22;
    ErrorHandling.ElementClassName := 'form-select';
    ErrorHandling.ElementFont := efCSS;
    ErrorHandling.HeightPercent := 100.000000000000000000;
    ErrorHandling.WidthPercent := 100.000000000000000000;
    ErrorHandling.ItemIndex := -1;
    HMRCPassword.SetParentComponent(Self);
    HMRCPassword.Name := 'HMRCPassword';
    HMRCPassword.Left := 352;
    HMRCPassword.Top := 350;
    HMRCPassword.Width := 249;
    HMRCPassword.Height := 22;
    HMRCPassword.AutoCompletion := acNone;
    HMRCPassword.AutoSelect := False;
    HMRCPassword.ChildOrder := 13;
    HMRCPassword.ElementClassName := 'form-control';
    HMRCPassword.ElementPosition := epIgnore;
    HMRCPassword.HeightStyle := ssAuto;
    HMRCPassword.HeightPercent := 100.000000000000000000;
    HMRCPassword.PasswordChar := '*';
    HMRCPassword.WidthStyle := ssAuto;
    HMRCPassword.WidthPercent := 100.000000000000000000;
    SetEvent(HMRCPassword, Self, 'OnExit', 'HMRCPasswordExit');
    UserClaimRef.SetParentComponent(Self);
    UserClaimRef.Name := 'UserClaimRef';
    UserClaimRef.Left := 134;
    UserClaimRef.Top := 408;
    UserClaimRef.Width := 121;
    UserClaimRef.Height := 22;
    UserClaimRef.AutoSelect := False;
    UserClaimRef.CharCase := wecUpperCase;
    UserClaimRef.ChildOrder := 13;
    UserClaimRef.ElementPosition := epIgnore;
    UserClaimRef.HeightStyle := ssAuto;
    UserClaimRef.HeightPercent := 100.000000000000000000;
    UserClaimRef.MaxLength := 20;
    UserClaimRef.WidthStyle := ssAuto;
    UserClaimRef.WidthPercent := 100.000000000000000000;
    SetEvent(UserClaimRef, Self, 'OnChange', 'UserClaimRefChange');
    SetEvent(UserClaimRef, Self, 'OnExit', 'UserClaimRefExit');
    PrepareClaimDataXXX.SetParentComponent(Self);
    PrepareClaimDataXXX.Name := 'PrepareClaimDataXXX';
    PrepareClaimDataXXX.Left := 64;
    PrepareClaimDataXXX.Top := 216;
    PrepareClaimDataXXX.Width := 488;
    PrepareClaimDataXXX.Height := 41;
    PrepareClaimDataXXX.HeightStyle := ssAuto;
    PrepareClaimDataXXX.WidthStyle := ssAuto;
    PrepareClaimDataXXX.BorderColor := clSilver;
    PrepareClaimDataXXX.ChildOrder := 15;
    PrepareClaimDataXXX.ElementFont := efCSS;
    PrepareClaimDataXXX.ElementHeaderClassName := 'thead-light';
    PrepareClaimDataXXX.ElementPosition := epIgnore;
    PrepareClaimDataXXX.ElementTableClassName := 'table table-striped table-bordered  table-hover';
    PrepareClaimDataXXX.Header.Caption := 'WOOOOOOOF';
    PrepareClaimDataXXX.Options.CellBorders := True;
    PrepareClaimDataXXX.Options.ResizeColumns := True;
    PrepareClaimDataXXX.Visible := False;
    PrepareClaimDataXXX.ColCount := 2;
    PrepareClaimDataXXX.RowCount := 2;
    OldestDateParameter.SetParentComponent(Self);
    OldestDateParameter.Name := 'OldestDateParameter';
    OldestDateParameter.Left := 248;
    OldestDateParameter.Top := 167;
    OldestDateParameter.Width := 160;
    OldestDateParameter.Height := 22;
    OldestDateParameter.ElementClassName := 'form-control';
    OldestDateParameter.HeightStyle := ssAuto;
    OldestDateParameter.WidthStyle := ssAuto;
    OldestDateParameter.BorderStyle := bsSingle;
    OldestDateParameter.ChildOrder := 18;
    OldestDateParameter.Color := clWhite;
    OldestDateParameter.Date := 46090.416217013890000000;
    OldestDateParameter.ElementPosition := epIgnore;
    OldestDateParameter.Role := '';
    OldestDateParameter.Text := '';
    SetEvent(OldestDateParameter, Self, 'OnChange', 'ParameterChange');
    NewestDateParameter.SetParentComponent(Self);
    NewestDateParameter.Name := 'NewestDateParameter';
    NewestDateParameter.Left := 248;
    NewestDateParameter.Top := 195;
    NewestDateParameter.Width := 160;
    NewestDateParameter.Height := 22;
    NewestDateParameter.ElementClassName := 'form-control';
    NewestDateParameter.HeightStyle := ssAuto;
    NewestDateParameter.WidthStyle := ssAuto;
    NewestDateParameter.BorderStyle := bsSingle;
    NewestDateParameter.ChildOrder := 18;
    NewestDateParameter.Color := clWhite;
    NewestDateParameter.Date := 46090.416217013890000000;
    NewestDateParameter.ElementPosition := epIgnore;
    NewestDateParameter.Role := '';
    NewestDateParameter.Text := '';
    SetEvent(NewestDateParameter, Self, 'OnChange', 'ParameterChange');
    ImportFiles.SetParentComponent(Self);
    ImportFiles.Name := 'ImportFiles';
    ImportFiles.Left := 248;
    ImportFiles.Top := 128;
    ImportFiles.Width := 160;
    ImportFiles.Height := 22;
    ImportFiles.ElementClassName := 'form-select';
    ImportFiles.ElementPosition := epIgnore;
    ImportFiles.HeightStyle := ssAuto;
    ImportFiles.HeightPercent := 100.000000000000000000;
    ImportFiles.WidthStyle := ssAuto;
    ImportFiles.WidthPercent := 100.000000000000000000;
    SetEvent(ImportFiles, Self, 'OnChange', 'ParameterChange');
    ImportFiles.ItemIndex := -1;
    PrepareWaitMessage.SetParentComponent(Self);
    PrepareWaitMessage.Name := 'PrepareWaitMessage';
    PrepareWaitMessage.Left := 8;
    PrepareWaitMessage.Top := 288;
    PrepareWaitMessage.Width := 24;
    PrepareWaitMessage.Height := 24;
    PrepareWaitMessage.Opacity := 0.200000000000000000;
    PrepareWaitMessage.Picture.LoadFromFile('GiftAidClaimForm.PrepareWaitMessage.Picture.gif');
    CancelPrepareClaimButton.SetParentComponent(Self);
    CancelPrepareClaimButton.Name := 'CancelPrepareClaimButton';
    CancelPrepareClaimButton.Left := 424;
    CancelPrepareClaimButton.Top := 132;
    CancelPrepareClaimButton.Width := 96;
    CancelPrepareClaimButton.Height := 25;
    CancelPrepareClaimButton.Caption := 'Cancel Prepare Claim';
    CancelPrepareClaimButton.ChildOrder := 21;
    CancelPrepareClaimButton.ElementClassName := 'btn btn-secondary';
    CancelPrepareClaimButton.ElementPosition := epIgnore;
    CancelPrepareClaimButton.HeightStyle := ssAuto;
    CancelPrepareClaimButton.HeightPercent := 100.000000000000000000;
    CancelPrepareClaimButton.WidthStyle := ssAuto;
    CancelPrepareClaimButton.WidthPercent := 100.000000000000000000;
    SetEvent(CancelPrepareClaimButton, Self, 'OnClick', 'CancelPrepareClaimButtonClick');
    PrepareClaimButton.SetParentComponent(Self);
    PrepareClaimButton.Name := 'PrepareClaimButton';
    PrepareClaimButton.Left := 64;
    PrepareClaimButton.Top := 136;
    PrepareClaimButton.Width := 178;
    PrepareClaimButton.Height := 25;
    PrepareClaimButton.Caption := 'Evaluate Claim';
    PrepareClaimButton.ChildOrder := 22;
    PrepareClaimButton.ElementClassName := 'btn btn-secondary';
    PrepareClaimButton.ElementPosition := epIgnore;
    PrepareClaimButton.HeightStyle := ssAuto;
    PrepareClaimButton.HeightPercent := 100.000000000000000000;
    PrepareClaimButton.WidthStyle := ssAuto;
    PrepareClaimButton.WidthPercent := 100.000000000000000000;
    SetEvent(PrepareClaimButton, Self, 'OnClick', 'PrepareClaimButtonClick');
    DeclarationTextMemo.SetParentComponent(Self);
    DeclarationTextMemo.Name := 'DeclarationTextMemo';
    DeclarationTextMemo.Left := 400;
    DeclarationTextMemo.Top := 93;
    DeclarationTextMemo.Width := 185;
    DeclarationTextMemo.Height := 89;
    DeclarationTextMemo.ElementPosition := epIgnore;
    DeclarationTextMemo.HeightStyle := ssAuto;
    DeclarationTextMemo.HeightPercent := 100.000000000000000000;
    DeclarationTextMemo.Lines.BeginUpdate;
    try
      DeclarationTextMemo.Lines.Clear;
      DeclarationTextMemo.Lines.Add('DeclarationTextMemo');
    finally
      DeclarationTextMemo.Lines.EndUpdate;
    end;
    DeclarationTextMemo.ReadOnly := True;
    DeclarationTextMemo.SelLength := 0;
    DeclarationTextMemo.SelStart := 0;
    DeclarationTextMemo.Visible := False;
    DeclarationTextMemo.WidthStyle := ssAuto;
    DeclarationTextMemo.WidthPercent := 100.000000000000000000;
    PrepareClaimData.SetParentComponent(Self);
    PrepareClaimData.Name := 'PrepareClaimData';
    PrepareClaimData.Left := 38;
    PrepareClaimData.Top := 249;
    PrepareClaimData.Width := 561;
    PrepareClaimData.Height := 123;
    PrepareClaimData.HeightStyle := ssAuto;
    PrepareClaimData.WidthStyle := ssAuto;
    PrepareClaimData.BorderColor := clSilver;
    PrepareClaimData.ChildOrder := 13;
    PrepareClaimData.ElementFont := efCSS;
    PrepareClaimData.ElementHeaderClassName := 'thead-light';
    PrepareClaimData.ElementPosition := epIgnore;
    PrepareClaimData.ElementTableClassName := 'table table-striped table-bordered  table-hover';
    PrepareClaimData.ColCount := 3;
    PrepareClaimData.RowCount := 2;
    ViewClaimDonationsButton.SetParentComponent(Self);
    ViewClaimDonationsButton.Name := 'ViewClaimDonationsButton';
    ViewClaimDonationsButton.Left := 408;
    ViewClaimDonationsButton.Top := 391;
    ViewClaimDonationsButton.Width := 145;
    ViewClaimDonationsButton.Height := 25;
    ViewClaimDonationsButton.Caption := 'View Donations';
    ViewClaimDonationsButton.ChildOrder := 23;
    ViewClaimDonationsButton.ElementClassName := 'btn btn-outline-primary';
    ViewClaimDonationsButton.ElementPosition := epIgnore;
    ViewClaimDonationsButton.HeightStyle := ssAuto;
    ViewClaimDonationsButton.HeightPercent := 100.000000000000000000;
    ViewClaimDonationsButton.WidthStyle := ssAuto;
    ViewClaimDonationsButton.WidthPercent := 100.000000000000000000;
    SetEvent(ViewClaimDonationsButton, Self, 'OnClick', 'ViewClaimDonationsButtonClick');
    JobsPlacedDateAdded.SetParentComponent(JobsPlaced);
    JobsPlacedDateAdded.Name := 'JobsPlacedDateAdded';
    JobsPlacedDateAdded.FieldName := 'DateAdded';
    JobsPlacedAddedBy.SetParentComponent(JobsPlaced);
    JobsPlacedAddedBy.Name := 'JobsPlacedAddedBy';
    JobsPlacedAddedBy.FieldName := 'AddedBy';
    JobsPlacedLastUpdatedBy.SetParentComponent(JobsPlaced);
    JobsPlacedLastUpdatedBy.Name := 'JobsPlacedLastUpdatedBy';
    JobsPlacedLastUpdatedBy.FieldName := 'LastUpdatedBy';
    JobsPlacedLastUpdated.SetParentComponent(JobsPlaced);
    JobsPlacedLastUpdated.Name := 'JobsPlacedLastUpdated';
    JobsPlacedLastUpdated.FieldName := 'LastUpdated';
    JobsPlacedJobCategory.SetParentComponent(JobsPlaced);
    JobsPlacedJobCategory.Name := 'JobsPlacedJobCategory';
    JobsPlacedJobCategory.FieldName := 'JobCategory';
    JobsPlacedJobCategory.Size := 8;
    JobsPlacedLastPolled.SetParentComponent(JobsPlaced);
    JobsPlacedLastPolled.Name := 'JobsPlacedLastPolled';
    JobsPlacedLastPolled.FieldName := 'LastPolled';
    JobsPlacedPollInterval.SetParentComponent(JobsPlaced);
    JobsPlacedPollInterval.Name := 'JobsPlacedPollInterval';
    JobsPlacedPollInterval.FieldName := 'PollInterval';
    JobsPlacedPollCount.SetParentComponent(JobsPlaced);
    JobsPlacedPollCount.Name := 'JobsPlacedPollCount';
    JobsPlacedPollCount.FieldName := 'PollCount';
    CloseTimer.Left := 32;
    CloseTimer.Top := 424;
    AuthOfficials.SetParentComponent(Self);
    AuthOfficials.Name := 'AuthOfficials';
    AuthOfficials.AfterOpen := AuthOfficialsAfterOpen;
    AuthOfficials.EntitySetName := 'User';
    AuthOfficials.Connection := MainData.DataConnection;
    AuthOfficials.Left := 456;
    AuthOfficials.Top := 64;
    AuthOfficialsId.SetParentComponent(AuthOfficials);
    AuthOfficialsId.Name := 'AuthOfficialsId';
    AuthOfficialsId.FieldName := 'Id';
    AuthOfficialsFirstName.SetParentComponent(AuthOfficials);
    AuthOfficialsFirstName.Name := 'AuthOfficialsFirstName';
    AuthOfficialsFirstName.FieldName := 'FirstName';
    AuthOfficialsFirstName.Size := 50;
    AuthOfficialsLastName.SetParentComponent(AuthOfficials);
    AuthOfficialsLastName.Name := 'AuthOfficialsLastName';
    AuthOfficialsLastName.FieldName := 'LastName';
    AuthOfficialsLastName.Size := 50;
    ConfigDataset.SetParentComponent(Self);
    ConfigDataset.Name := 'ConfigDataset';
    ConfigDataset.AfterOpen := ConfigDatasetAfterOpen;
    ConfigDataset.EntitySetName := 'GiftAidParams';
    ConfigDataset.Connection := MainData.DataConnection;
    ConfigDataset.Left := 544;
    ConfigDataset.Top := 64;
    ConfigDatasetId.SetParentComponent(ConfigDataset);
    ConfigDatasetId.Name := 'ConfigDatasetId';
    ConfigDatasetId.FieldName := 'Id';
    ConfigDatasetHMRCOfficial.SetParentComponent(ConfigDataset);
    ConfigDatasetHMRCOfficial.Name := 'ConfigDatasetHMRCOfficial';
    ConfigDatasetHMRCOfficial.FieldName := 'HMRCOfficial';
    ConfigDatasetCharityRef.SetParentComponent(ConfigDataset);
    ConfigDatasetCharityRef.Name := 'ConfigDatasetCharityRef';
    ConfigDatasetCharityRef.FieldName := 'CharityRef';
    ConfigDatasetCharityRef.Size := 50;
    ConfigDatasetCharityType.SetParentComponent(ConfigDataset);
    ConfigDatasetCharityType.Name := 'ConfigDatasetCharityType';
    ConfigDatasetCharityType.FieldName := 'CharityType';
    ConfigDatasetCharityType.Size := 15;
    ConfigDatasetGatewayId.SetParentComponent(ConfigDataset);
    ConfigDatasetGatewayId.Name := 'ConfigDatasetGatewayId';
    ConfigDatasetGatewayId.FieldName := 'GatewayId';
    ConfigDatasetGatewayId.Size := 50;
    ConfigDatasetGatewayPassword.SetParentComponent(ConfigDataset);
    ConfigDatasetGatewayPassword.Name := 'ConfigDatasetGatewayPassword';
    ConfigDatasetGatewayPassword.FieldName := 'GatewayPassword';
    ConfigDatasetGatewayPassword.Size := 64;
    ConfigDatasetRegulator.SetParentComponent(ConfigDataset);
    ConfigDatasetRegulator.Name := 'ConfigDatasetRegulator';
    ConfigDatasetRegulator.FieldName := 'Regulator';
    ConfigDatasetRegulator.Size := 5;
    ConfigDatasetRegulatorNumber.SetParentComponent(ConfigDataset);
    ConfigDatasetRegulatorNumber.Name := 'ConfigDatasetRegulatorNumber';
    ConfigDatasetRegulatorNumber.FieldName := 'RegulatorNumber';
    ConfigDatasetRegulatorNumber.Size := 50;
    ConfigDatasetEndOfYear.SetParentComponent(ConfigDataset);
    ConfigDatasetEndOfYear.Name := 'ConfigDatasetEndOfYear';
    ConfigDatasetEndOfYear.FieldName := 'EndOfYear';
    ConfigDatasetEndOfYear.Size := 5;
    ConfigDatasetOrganisationType.SetParentComponent(ConfigDataset);
    ConfigDatasetOrganisationType.Name := 'ConfigDatasetOrganisationType';
    ConfigDatasetOrganisationType.FieldName := 'OrganisationType';
    ConfigDatasetOrganisationType.Size := 16;
    ConfigDatasetOrganisationName.SetParentComponent(ConfigDataset);
    ConfigDatasetOrganisationName.Name := 'ConfigDatasetOrganisationName';
    ConfigDatasetOrganisationName.FieldName := 'OrganisationName';
    ConfigDatasetOrganisationName.Size := 250;
    ConfigDatasetSubmissionMethod.SetParentComponent(ConfigDataset);
    ConfigDatasetSubmissionMethod.Name := 'ConfigDatasetSubmissionMethod';
    ConfigDatasetSubmissionMethod.FieldName := 'SubmissionMethod';
    ConfigDatasetSubmissionMethod.Size := 4;
    GAUsers.SetParentComponent(Self);
    GAUsers.Name := 'GAUsers';
    GAUsers.Left := 8;
    GAUsers.Top := 16;
    InitialCheck.SetParentComponent(Self);
    InitialCheck.Name := 'InitialCheck';
    InitialCheck.Enabled := False;
    SetEvent(InitialCheck, Self, 'OnTimer', 'InitialCheckTimer');
    InitialCheck.Left := 576;
    InitialCheck.Top := 136;
    DisplayClaimDeclaration.SetParentComponent(Self);
    DisplayClaimDeclaration.Name := 'DisplayClaimDeclaration';
    DisplayClaimDeclaration.Enabled := False;
    SetEvent(DisplayClaimDeclaration, Self, 'OnTimer', 'DisplayClaimDeclarationTimer');
    DisplayClaimDeclaration.Left := 576;
    DisplayClaimDeclaration.Top := 264;
    ClaimDeclaration.SetParentComponent(Self);
    ClaimDeclaration.Name := 'ClaimDeclaration';
    ClaimDeclaration.AfterPost := ClaimDeclarationAfterPost;
    ClaimDeclaration.EntitySetName := 'ClaimDeclaration';
    ClaimDeclaration.Connection := MainData.DataConnection;
    ClaimDeclaration.Left := 472;
    ClaimDeclaration.Top := 136;
    ClaimDeclarationId.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationId.Name := 'ClaimDeclarationId';
    ClaimDeclarationId.FieldName := 'Id';
    ClaimDeclarationDateAdded.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationDateAdded.Name := 'ClaimDeclarationDateAdded';
    ClaimDeclarationDateAdded.FieldName := 'DateAdded';
    ClaimDeclarationAddedBy.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationAddedBy.Name := 'ClaimDeclarationAddedBy';
    ClaimDeclarationAddedBy.FieldName := 'AddedBy';
    ClaimDeclarationLastUpdatedBy.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationLastUpdatedBy.Name := 'ClaimDeclarationLastUpdatedBy';
    ClaimDeclarationLastUpdatedBy.FieldName := 'LastUpdatedBy';
    ClaimDeclarationLastUpdated.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationLastUpdated.Name := 'ClaimDeclarationLastUpdated';
    ClaimDeclarationLastUpdated.FieldName := 'LastUpdated';
    ClaimDeclarationClaimId.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationClaimId.Name := 'ClaimDeclarationClaimId';
    ClaimDeclarationClaimId.FieldName := 'ClaimId';
    ClaimDeclarationDeclarationVersion.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationDeclarationVersion.Name := 'ClaimDeclarationDeclarationVersion';
    ClaimDeclarationDeclarationVersion.FieldName := 'DeclarationVersion';
    ClaimDeclarationDeclarationHash.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationDeclarationHash.Name := 'ClaimDeclarationDeclarationHash';
    ClaimDeclarationDeclarationHash.FieldName := 'DeclarationHash';
    ClaimDeclarationDeclarationHash.Size := 64;
    ClaimDeclarationDeclarationIssueDate.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationDeclarationIssueDate.Name := 'ClaimDeclarationDeclarationIssueDate';
    ClaimDeclarationDeclarationIssueDate.FieldName := 'DeclarationIssueDate';
    ClaimDeclarationDeclarationExpiryDate.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationDeclarationExpiryDate.Name := 'ClaimDeclarationDeclarationExpiryDate';
    ClaimDeclarationDeclarationExpiryDate.FieldName := 'DeclarationExpiryDate';
    ClaimDeclarationDeclarationSignedDate.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationDeclarationSignedDate.Name := 'ClaimDeclarationDeclarationSignedDate';
    ClaimDeclarationDeclarationSignedDate.FieldName := 'DeclarationSignedDate';
    ClaimDeclarationDeclarationSignedByUser.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationDeclarationSignedByUser.Name := 'ClaimDeclarationDeclarationSignedByUser';
    ClaimDeclarationDeclarationSignedByUser.FieldName := 'DeclarationSignedByUser';
    ClaimDeclarationDeclarationByName.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationDeclarationByName.Name := 'ClaimDeclarationDeclarationByName';
    ClaimDeclarationDeclarationByName.FieldName := 'DeclarationByName';
    ClaimDeclarationDeclarationByName.Size := 100;
    ClaimDeclarationDeclarationSigningChannel.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationDeclarationSigningChannel.Name := 'ClaimDeclarationDeclarationSigningChannel';
    ClaimDeclarationDeclarationSigningChannel.FieldName := 'DeclarationSigningChannel';
    ClaimDeclarationDeclarationSigningChannel.Size := 10;
    ClaimDeclarationDeclarationStatus.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationDeclarationStatus.Name := 'ClaimDeclarationDeclarationStatus';
    ClaimDeclarationDeclarationStatus.FieldName := 'DeclarationStatus';
    ClaimDeclarationDeclarationStatus.Size := 8;
    ClaimDeclarationSignedDeclarationText.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationSignedDeclarationText.Name := 'ClaimDeclarationSignedDeclarationText';
    ClaimDeclarationSignedDeclarationText.FieldName := 'SignedDeclarationText';
    ClaimDeclarationSignedDeclarationText.Size := 2048;
    PrepareClaimTimer.SetParentComponent(Self);
    PrepareClaimTimer.Name := 'PrepareClaimTimer';
    PrepareClaimTimer.Enabled := False;
    SetEvent(PrepareClaimTimer, Self, 'OnTimer', 'PrepareClaimTimerTimer');
    PrepareClaimTimer.Left := 576;
    PrepareClaimTimer.Top := 416;
  finally
    JobsPlacedTable.AfterLoadDFMValues;
    CancelButton.AfterLoadDFMValues;
    PlaceJobButton.AfterLoadDFMValues;
    OutputOption.AfterLoadDFMValues;
    JobVisibility.AfterLoadDFMValues;
    WaitMessage.AfterLoadDFMValues;
    JobRunType.AfterLoadDFMValues;
    AgreeCheckBox.AfterLoadDFMValues;
    AuthorisedOfficial.AfterLoadDFMValues;
    ErrorHandling.AfterLoadDFMValues;
    HMRCPassword.AfterLoadDFMValues;
    UserClaimRef.AfterLoadDFMValues;
    PrepareClaimDataXXX.AfterLoadDFMValues;
    OldestDateParameter.AfterLoadDFMValues;
    NewestDateParameter.AfterLoadDFMValues;
    ImportFiles.AfterLoadDFMValues;
    PrepareWaitMessage.AfterLoadDFMValues;
    CancelPrepareClaimButton.AfterLoadDFMValues;
    PrepareClaimButton.AfterLoadDFMValues;
    DeclarationTextMemo.AfterLoadDFMValues;
    PrepareClaimData.AfterLoadDFMValues;
    ViewClaimDonationsButton.AfterLoadDFMValues;
    JobsPlaced.AfterLoadDFMValues;
    JobsPlacedDateAdded.AfterLoadDFMValues;
    JobsPlacedAddedBy.AfterLoadDFMValues;
    JobsPlacedLastUpdatedBy.AfterLoadDFMValues;
    JobsPlacedLastUpdated.AfterLoadDFMValues;
    JobsPlacedJobCategory.AfterLoadDFMValues;
    JobsPlacedLastPolled.AfterLoadDFMValues;
    JobsPlacedPollInterval.AfterLoadDFMValues;
    JobsPlacedPollCount.AfterLoadDFMValues;
    CloseTimer.AfterLoadDFMValues;
    AuthOfficials.AfterLoadDFMValues;
    AuthOfficialsId.AfterLoadDFMValues;
    AuthOfficialsFirstName.AfterLoadDFMValues;
    AuthOfficialsLastName.AfterLoadDFMValues;
    ConfigDataset.AfterLoadDFMValues;
    ConfigDatasetId.AfterLoadDFMValues;
    ConfigDatasetHMRCOfficial.AfterLoadDFMValues;
    ConfigDatasetCharityRef.AfterLoadDFMValues;
    ConfigDatasetCharityType.AfterLoadDFMValues;
    ConfigDatasetGatewayId.AfterLoadDFMValues;
    ConfigDatasetGatewayPassword.AfterLoadDFMValues;
    ConfigDatasetRegulator.AfterLoadDFMValues;
    ConfigDatasetRegulatorNumber.AfterLoadDFMValues;
    ConfigDatasetEndOfYear.AfterLoadDFMValues;
    ConfigDatasetOrganisationType.AfterLoadDFMValues;
    ConfigDatasetOrganisationName.AfterLoadDFMValues;
    ConfigDatasetSubmissionMethod.AfterLoadDFMValues;
    GAUsers.AfterLoadDFMValues;
    InitialCheck.AfterLoadDFMValues;
    DisplayClaimDeclaration.AfterLoadDFMValues;
    ClaimDeclaration.AfterLoadDFMValues;
    ClaimDeclarationId.AfterLoadDFMValues;
    ClaimDeclarationDateAdded.AfterLoadDFMValues;
    ClaimDeclarationAddedBy.AfterLoadDFMValues;
    ClaimDeclarationLastUpdatedBy.AfterLoadDFMValues;
    ClaimDeclarationLastUpdated.AfterLoadDFMValues;
    ClaimDeclarationClaimId.AfterLoadDFMValues;
    ClaimDeclarationDeclarationVersion.AfterLoadDFMValues;
    ClaimDeclarationDeclarationHash.AfterLoadDFMValues;
    ClaimDeclarationDeclarationIssueDate.AfterLoadDFMValues;
    ClaimDeclarationDeclarationExpiryDate.AfterLoadDFMValues;
    ClaimDeclarationDeclarationSignedDate.AfterLoadDFMValues;
    ClaimDeclarationDeclarationSignedByUser.AfterLoadDFMValues;
    ClaimDeclarationDeclarationByName.AfterLoadDFMValues;
    ClaimDeclarationDeclarationSigningChannel.AfterLoadDFMValues;
    ClaimDeclarationDeclarationStatus.AfterLoadDFMValues;
    ClaimDeclarationSignedDeclarationText.AfterLoadDFMValues;
    PrepareClaimTimer.AfterLoadDFMValues;
  end;
end;

end.
